import DealLockReason from "@app/enum/DealLockReason";

import dealLockMessages from "./dealLockMessages";
import notifyDealWarning from "./notifyDealWarning";

// Says why a deal action was held back by the deal's lock
const notifyDealLocked = (reason: DealLockReason) => notifyDealWarning(dealLockMessages[reason]);

export default notifyDealLocked;
